export default class GTMHelper {
  constructor() {
    console.log("GTM INITIALIZED");
  }

  static raiseEvent(pushParams) {
    // console.log("Push ", pushParams);
    window.dataLayer = window.dataLayer || [];
    dataLayer.push(...pushParams);
  }
}
